import { useEventListener } from "@vueuse/core";
import { useRouter } from "vue-router";

/** Sent by the messaging service worker (public/notification-click.js) to a tab it focused for a push click. */
export const OPEN_NOTIFICATION_LINK_MESSAGE = "verbleif:open-notification-link";

/** The in-app location of a URL the worker asks to open, or null for anything not of this origin. */
export function notificationLinkLocation(data: unknown, origin: string): string | null {
  if (typeof data !== "object" || data === null) {
    return null;
  }
  const message = data as { type?: unknown, url?: unknown };
  if (message.type !== OPEN_NOTIFICATION_LINK_MESSAGE || typeof message.url !== "string") {
    return null;
  }
  try {
    const url = new URL(message.url);
    return url.origin === origin ? `${url.pathname}${url.search}${url.hash}` : null;
  } catch {
    return null;
  }
}

/**
 * A click on a push notification focuses an open Verbleif tab instead of opening a new one; the worker cannot
 * navigate a tab it does not control, so the tab opens the push's screen itself.
 */
export function useNotificationClickMessages() {
  const router = useRouter();
  const serviceWorker = typeof navigator !== "undefined" ? navigator.serviceWorker : undefined;
  if (!serviceWorker) {
    return;
  }

  useEventListener(serviceWorker, "message", (event: MessageEvent) => {
    const location = notificationLinkLocation(event.data, window.location.origin);
    if (location !== null) {
      void router.push(location);
    }
  });
}
